module.exports = {"id":"dp1_2l1q6","text":"Evaluating Information","instructions":"Is checking the source useful when deciding if information is reliable?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":false,"options":[{"id":"dp1_2l1q6-a1","text":"Yes","score":1.8},{"id":"dp1_2l1q6-a2","text":"Not sure","score":0},{"id":"dp1_2l1q6-a3","text":"No","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l1q6.json
// module id = 948
// module chunks = 41